import { ListChecks } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerListsSpec: ModuleSpec = {
  id: "customer-lists",
  icon: ListChecks,
  i18n: {
    namespace: "modules",
    titleKey: "customer-lists.title",
    descriptionKey: "customer-lists.description",
  },
  nav: {
    path: "/customers/lists",
    group: "observe",
    order: 110,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Manage profile lists for batch operations",
  },
};
